
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6002fc4e\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./ajouterLangue.scss")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./ajouterLangue.ts"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6002fc4e\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ajouterLangue.vue.html"),
  /* scopeId */
  "data-v-6002fc4e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ficheSalarie/competences/modals/ajouterLangue/ajouterLangue.vue.html
// module id = l2N4
// module chunks = 2